import { TableTemplate } from "components/templates/default/table/TableTemplate";
import Status from "components/blocks/status/Status";
import { RecorderHealthRow } from "api/interfaces/reportInterface.interface";
import HealthDetail from "./HealthDetail";
import { Routes, Route } from "react-router-dom";
import { healthAlertStatus } from "pages/dashboard/map/sub/subheader/filters/status/StatusFilter";
import {
  StatusLabel,
  StatusName,
  StatusValue,
} from "components/blocks/status/Status";
import * as s from "./HealthStyled";
import DetailButton from "components/atoms/buttons/detail/DetailButton";
import { ClickSearch } from "components/atoms/input/search/SearchInput";
import * as mediaQuery from "components/MediaQuery";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import { Fragment } from "react";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";

import { TableColumnsType } from "antd";
import {
  CommonTable,
  ExpandTableContainer,
} from "components/atoms/table/AntdTable";
import { AlertDetail } from "./HealthContainer";
import { useMenu } from "hook/useMenu";
import { formatNumber } from "utils/functions";
import { ExpandableConfig } from "antd/es/table/interface";

interface Count {
  [key: string]: number;
}

type Props = {
  title: string | undefined;
  columns: TableColumnsType<RecorderHealthRow>;
  data: RecorderHealthRow[];
  totalCount: Count;
  alertDetail: AlertDetail;
  // mergedState: any;
  reportId: string;
  onRowClicked: (row: any) => void;
  onChangePage: (page: number, totalRows: number) => void;
  onClickSearch: ClickSearch;
  paginationInfo: BasePagination;
  selectedAccount: ProfileAccountInfo;
  tablePending: boolean;
  expandableProps: ExpandableConfig<RecorderHealthRow>;
  activeExpandRow: string | undefined;
};

export default function HealthPresenter(props: Props): JSX.Element {
  const { menuNavigation } = useMenu({});

  //status
  const status = {
    totalTitle: "",
    items: healthAlertStatus.map((stat, idx) => {
      return (
        <StatusLabel key={idx}>
          {stat.icon}
          <StatusName>{stat.label}</StatusName>
          <StatusValue color={stat.color}>
            {formatNumber(props.totalCount[stat.value])}
          </StatusValue>
        </StatusLabel>
      );
    }),
  };

  const detailItems = [
    {
      name: "system",
      value: props.alertDetail.system,
      label: "System Alerts",
    },
    {
      name: "disk",
      value: props.alertDetail.disk,
      label: "Disk Alerts",
    },
    {
      name: "video",
      value: props.alertDetail.video,
      label: "Video Alerts",
    },
  ];

  const centerChildren = (
    <s.StatusWrapper>
      <Status status={status} />
      <Fragment />
      <mediaQuery.Default>
        <DetailButton
          title={"Health problems by category"}
          contents={detailItems}
        />
      </mediaQuery.Default>
    </s.StatusWrapper>
  );

  const titleComponent = [
    {
      label: "Report List",
      onClick: () => menuNavigation({ to: "/reports" }),
      //navigate("/reports"),
    },
    {
      label: props.title,
    },
  ];

  const Health = (
    <TableTemplate
      centerChildren={centerChildren}
      titleComponent={titleComponent}
      onClickSearch={props.onClickSearch}
      keyword={props.paginationInfo.keyword}
    >
      <ExpandTableContainer>
        <CommonTable
          columns={props.columns}
          dataSource={props.data}
          queryInfo={props.paginationInfo}
          onChangePage={props.onChangePage}
          loading={props.tablePending}
          expandable={props.expandableProps}
          rowKey={(row: RecorderHealthRow) => row.mergedSystemId}
        />
      </ExpandTableContainer>
    </TableTemplate>
  );

  return (
    <Routes>
      <Route index element={Health} />
      <Route path="detail" element={<HealthDetail />} />
    </Routes>
  );
}
